import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { AppConfig } from 'AppConfig';
import axios from 'axios';
import { FoMaterialTable } from 'common/FoMaterialTable';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../actions/Actions';
import TpaSelection from './TpaSelection';

const TPA = ({ tenantId }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.masterTable.tenantTpas);

  const isLoading = useSelector((state) => state.masterTable.tpaLoading);

  const [open, setOpen] = useState(false);

  const handleOpenSelection = () => {
    setOpen(true);
  };

  const handleSaveSelection = (rows) => {
    if (rows && Array.isArray(rows) && rows.length > 0) {
      let names = [];

      rows.forEach((item) => {
        names.push(item.name);
      });

      let tpas = {
        tenantId: tenantId,
        name: names
      };

      dispatch({
        type: Actions.MASTER_TABLE_SAVE_TPA_FOR_TENENT
      });

      axios
        .post(
          AppConfig.API_BASE_URL + 'tpa/addlist',
          tpas,
          AppConfig.POST_HEADERS
        )
        .then((m) => {
          dispatch({
            type: Actions.MASTER_TABLE_SAVE_TPA_FOR_TENENT_SUCCESS
          });
          refresh();
          setOpen(false);
        })
        .catch((err) =>
          dispatch({
            type: Actions.MASTER_TABLE_SAVE_TPA_FOR_TENENT_FAILURE
          })
        );
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteSelected = (row) => {
    let ids = [];

    row.forEach((item) => {
      ids.push(item.id);
    });
    if (ids && Array.isArray(ids) && ids.length > 0) {
      axios
        .delete(AppConfig.API_BASE_URL + `tpa/mult`, { data: ids })
        .then((m) => {
          refresh();
        })
        .catch((err) =>
          dispatch({
            type: Actions.MASTER_TABLE_DELETE_TPA_FOR_TENENT_FAILURE
          })
        );
    }
  };

  const refresh = () => {
    dispatch({
      type: Actions.MASTER_TABLE_GET_TPA_FOR_TENENT
    });

    axios
      .get(AppConfig.API_BASE_URL + `tpa`)
      .then((m) => {
        dispatch({
          type: Actions.MASTER_TABLE_GET_TPA_FOR_TENENT_SUCCESS,
          data: m.data
        });
      })
      .catch((err) => {
        dispatch({
          type: Actions.MASTER_TABLE_GET_TPA_FOR_TENENT_FAILURE
        });
      });
  };
  useEffect(() => {
    refresh();
  }, [tenantId]);

  return (
    <>
      <FoMaterialTable
        title="TPA"
        isLoading={isLoading}
        columns={[{ title: 'Name', field: 'name' }]}
        data={data}
        options={{
          selection: true
        }}
        components={{ OverlayLoading: () => <div /> }}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: 'Add TPA To Tenant',
            isFreeAction: true,
            onClick: (event) => handleOpenSelection()
          },
          {
            tooltip: 'Remove All Selected TPA(s)',
            icon: () => <DeleteIcon />,
            onClick: (evt, data) => deleteSelected(data)
          }
        ]}
      />

      <TpaSelection
        open={open}
        onSave={handleSaveSelection}
        onClose={handleClose}
        tenantId={tenantId}
      />
    </>
  );
};

export default TPA;
